var _circle, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLocaleRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 45,
    r: 45,
    fill: "#FF4B4B",
    fillOpacity: 0.09
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.4341 41.0914V41.115C27.6032 45.705 29.2301 50.1303 32.0899 53.778L32.1038 53.7957C35.4756 58.1914 39.6134 61.9736 44.328 64.9693C44.4104 65.0217 44.489 65.0795 44.5634 65.1423C44.6337 65.2016 44.738 65.2016 44.8083 65.1423C44.8847 65.0777 44.9656 65.0185 45.0505 64.965C48.2131 62.9719 51.1293 60.6287 53.741 57.9821C58.3283 53.2543 61.8131 47.4561 61.9375 41.4107V41.2166L61.9375 41.2094C61.9699 31.9081 54.2723 24.3423 44.7444 24.3107C35.2178 24.2791 27.4684 31.7918 27.4341 41.0914ZM23.1026 41.0806C23.1431 29.4439 32.839 20.0426 44.7591 20.0822C56.6782 20.1217 66.3078 29.5853 66.2691 41.2205V41.4312L66.2687 41.4712C66.1222 49.0266 61.8279 55.7985 56.8792 60.8967L56.8673 60.909C54.0522 63.7627 50.9121 66.2925 47.5082 68.4492C45.8584 69.7384 43.5085 69.7374 41.8598 68.4463C36.7661 65.1926 32.2933 61.0954 28.6432 56.3391C25.2328 51.9854 23.2966 46.7025 23.1038 41.2248C23.103 41.2006 23.1025 41.1764 23.1025 41.1522L23.1026 41.0806Z",
    fill: "#FF4B4B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.5751 35.5536C39.0562 35.0726 39.8209 35.0574 40.2833 35.5197L51.4589 46.6953C51.9212 47.1576 51.906 47.9224 51.425 48.4034C50.9439 48.8845 50.1791 48.8997 49.7168 48.4374L38.5412 37.2618C38.0788 36.7995 38.094 36.0347 38.5751 35.5536Z",
    fill: "#FF4B4B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.5751 48.4035C38.094 47.9224 38.0788 47.1576 38.5411 46.6953L49.7167 35.5197C50.1791 35.0573 50.9438 35.0725 51.4249 35.5536C51.906 36.0347 51.9211 36.7995 51.4588 37.2618L40.2832 48.4374C39.8209 48.8997 39.0561 48.8845 38.5751 48.4035Z",
    fill: "#FF4B4B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.5751 35.5536C39.0562 35.0726 39.8209 35.0574 40.2833 35.5197L51.4589 46.6953C51.9212 47.1576 51.906 47.9224 51.425 48.4034C50.9439 48.8845 50.1791 48.8997 49.7168 48.4374L38.5412 37.2618C38.0788 36.7995 38.094 36.0347 38.5751 35.5536Z",
    stroke: "#FF4B4B",
    strokeWidth: 0.755102,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.5751 48.4035C38.094 47.9224 38.0788 47.1576 38.5411 46.6953L49.7167 35.5197C50.1791 35.0573 50.9438 35.0725 51.4249 35.5536C51.906 36.0347 51.9211 36.7995 51.4588 37.2618L40.2832 48.4374C39.8209 48.8997 39.0561 48.8845 38.5751 48.4035Z",
    stroke: "#FF4B4B",
    strokeWidth: 0.755102,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLocaleRed);
export default __webpack_public_path__ + "static/media/icon-locale-red.0318e274f5a0cec4eaad70b69817bcd0.svg";
export { ForwardRef as ReactComponent };